import { Module } from 'vuex'

import { makeBaseList } from '../models'
import { RootState } from '../state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { QrCodesState } from './state'

const namespaced = true

const state: QrCodesState = {
  ...makeBaseList(),
  query: {}
}

const module: Module<QrCodesState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}

export default module
